/**
 * defa.models.RecipientGroup
 * The DEFA RecipientGroup model.
 * @version 1.0.0
 */

import Model    from '../../poppet/model';
import { defa } from '../../../defa-object';

const channel = Bb.Radio.channel('objects');
const apiHost = defa.vars.apiHost;
const api = {
	unitUrl: apiHost,
	recipients: '/notificationrecipients',
};

export const Recipient = Model.extend({
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: {
		
		unit: null,
		
		notificationGroup: null,
		
		type: '',
		
		recipient: '',
		
		emergencyLevel: false,
		
		generalLevel: false
	},
	
	url: function ( ) {
		return this.get('id')
			   ? apiHost + api.recipients + '/' + this.get('id')
			   : apiHost + api.recipients
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Parses incoming data before creating/updating the model.
	 * @param  {object} response  The response from the server.
	 * @overwrite
	 */
	parse: function(response){
		if(response){
			let recipientGroupHolder = channel.request('recipientGroupHolders').get(this.get('unit'));
			let recipientGroup = recipientGroupHolder.get('recipientGroups').get(response.notificationGroup)
			let recipients = recipientGroup.get('notificationRecipients');
			recipients.add(response, { merge: true });
		}
		return response
	},
});
export default Recipient;
